import { Link } from "react-router-dom";

const year = new Date().getFullYear();

export default function SiteFooter() {
  return (
    <footer className="bg-primary-50 border-t border-primary-100/60">
      <div className="px-4 md:px-8 lg:px-12 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3">
              <span className="w-10 h-10 rounded-md bg-primary-500 text-background-50 flex items-center justify-center">
                <i className="ri-film-line text-xl" aria-hidden="true"></i>
              </span>
              <div>
                <p className="font-heading text-foreground-950 text-base font-semibold">
                  韩国伦理电影在线观看
                </p>
                <p className="font-label text-[11px] tracking-[0.3em] text-primary-300 mt-1">
                  KOREAN CINEMA ARCHIVE
                </p>
              </div>
            </div>
            <p className="mt-5 text-sm leading-relaxed text-secondary-900 max-w-md">
              专注韩国伦理题材电影的整理与推荐，提供影片资料、分类检索与观影界面演示。
              站内影片信息为虚构示例，播放区域仅作界面展示，不提供真实片源。
            </p>
            <div className="mt-6 flex items-center gap-3">
              {[
                { icon: "ri-mail-line", label: "邮件" },
                { icon: "ri-wechat-line", label: "微信" },
                { icon: "ri-weibo-line", label: "微博" },
                { icon: "ri-instagram-line", label: "Instagram" },
              ].map((item) => (
                <span
                  key={item.icon}
                  className="w-9 h-9 rounded-md border border-primary-200/60 flex items-center justify-center text-primary-300 hover:text-primary-500 hover:border-primary-400 transition-colors cursor-pointer"
                  aria-label={item.label}
                  title={item.label}
                >
                  <i className={item.icon} aria-hidden="true"></i>
                </span>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-foreground-950 mb-4 tracking-wide">浏览片库</h3>
            <ul className="space-y-2.5 text-sm">
              {[
                { label: "剧情伦理电影", to: "/category/drama" },
                { label: "爱情伦理电影", to: "/category/romance" },
                { label: "社会伦理电影", to: "/category/society" },
                { label: "全部影片", to: "/category/all" },
                { label: "站内搜索", to: "/search" },
              ].map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    className="text-secondary-900 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-foreground-950 mb-4 tracking-wide">关于站点</h3>
            <ul className="space-y-2.5 text-sm">
              {[
                { label: "关于我们", to: "/about" },
                { label: "联系我们", to: "/contact" },
                { label: "内容范围说明", to: "/about" },
                { label: "版权与免责声明", to: "/about" },
              ].map((item) => (
                <li key={item.label}>
                  <Link
                    to={item.to}
                    className="text-secondary-900 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
            <p className="mt-6 text-xs leading-relaxed text-secondary-800">
              本站内容仅面向成年观众，
              <br />
              请合理安排观影时间。
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-primary-200/40 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-secondary-800">
            © {year} 韩国伦理电影在线观看. 保留所有权利。站内影片与人物均为虚构示例。
          </p>
          <p className="text-xs text-secondary-800">
            资料整理 · 分类检索 · 观影界面演示
          </p>
        </div>
      </div>
    </footer>
  );
}